module.exports = __webpack_public_path__ + "img/20190622141607微信截图_20190622142008.c3a9dd47.png";